import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { useAuth } from "@/context/AuthContext";
import { formatError } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await register(form); toast.success("Account created"); nav("/dashboard"); }
    catch (err) { toast.error(formatError(err)); } finally { setLoading(false); }
  };

  return (
    <PublicLayout>
      <section className="container-x py-24 max-w-md">
        <div className="overline mb-3">Create account</div>
        <h1 className="font-display text-4xl font-black tracking-tighter">Start your AI journey.</h1>
        <form onSubmit={onSubmit} className="mt-8 glass rounded-2xl p-8 space-y-4" data-testid="register-form">
          <Field label="Full name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="register-name" />
          <Field label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="register-email" />
          <Field label="Phone (optional)" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} testid="register-phone" required={false} />
          <Field label="Password" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="register-password" />
          <button type="submit" disabled={loading} className="btn-neon w-full" data-testid="register-submit">{loading ? "..." : "Create account"}</button>
          <p className="text-sm text-ink-500 text-center">Already have an account? <Link to="/login" className="text-gold">Log in</Link></p>
        </form>
      </section>
    </PublicLayout>
  );
}

const Field = ({ label, value, onChange, type = "text", required = true, testid }) => (
  <label className="block">
    <div className="overline mb-2">{label}</div>
    <input type={type} value={value} required={required} onChange={(e) => onChange(e.target.value)}
      className="w-full rounded-lg bg-ink-900/[0.04] border border-ink-900/10 px-4 py-3 outline-none focus:border-neon" data-testid={testid} />
  </label>
);
